import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { Game } from 'config/types/game'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { RowCenter } from 'layout/Components/Row'
import { forwardRef } from 'react'
import { useAuth } from 'state/auth/hooks'
import GameScreenBouns from './GameScreenBouns'

interface GameFrameProps extends BoxProps {
  isMinimize: boolean
  game: Game
  isBelowBreakpoint?: boolean
  children: React.ReactNode
}

const GameFrame = forwardRef<HTMLDivElement, GameFrameProps>(
  ({ isMinimize, children, game, isBelowBreakpoint = false, ...props }, ref) => {
    const { hasSession } = useAuth()
    const { isDesktop } = useMatchBreakpoints()

    return (
      <Box
        ref={ref}
        pt={isMinimize && '0 !important'}
        position="relative"
        p={hasSession ? '56px 0 65px' : '0 0 65px'}
        height={
          isMinimize
            ? 'calc(100vh - 76px)'
            : [
                'calc(100vh - 140px - var(--notification-bar-height))',
                '',
                '',
                'calc(100vh - 76px - var(--notification-bar-height))',
              ]
        }
        width="100%"
        maxWidth={
          isMinimize
            ? '100%'
            : [
                `calc(calc(100% - 140px${hasSession ? ' - 128px' : ''} - var(--notification-bar-height)) * 16 / 9)`,
                '',
                '',
                `calc(calc(100% - 76px${hasSession ? ' - 128px' : ''} - var(--notification-bar-height)) * 16 / 9)`,
              ]
        }
        {...props}
      >
        {!isMinimize && isDesktop && !isBelowBreakpoint && (
          <RowCenter
            justifyContent="flex-start !important"
            position="absolute"
            top="0"
            left="4px"
            width="100%"
            height="56px"
            maxWidth="calc(100% - 8px)"
            display={['none !important', '', 'flex !important']}
          >
            <GameScreenBouns game={game} />
          </RowCenter>
        )}

        {children}
      </Box>
    )
  },
)

export default GameFrame
